<div class="layout-col full">
  <span style="width: 90vw"></span>

  <app-work-center-type-detail
    class="flex"
    [workCenterType]="workCenterType"
    (close)="onClose($event)"
  >
  </app-work-center-type-detail>
</div>
